/**
 * FontSizeControl — Continuous slider for end-user font size (rem).
 *
 * @module components/accessibility/FontSizeControl
 */
import React from 'react';
import { Box, Slider, Typography } from '@mui/material';
import { Trans } from '@lingui/react/macro';
import { useAccessibilitySettings } from '../../hooks/useAccessibilitySettings';

const marks = [
  { value: 0.875, label: '0.875' },
  { value: 1, label: '1' },
  { value: 1.25, label: '1.25' },
  { value: 1.5, label: '1.5' },
];

export const FontSizeControl: React.FC = () => {
  const { fontSize, updateSettings } = useAccessibilitySettings();

  const handleChange = (_: Event, value: number | number[]) => {
    updateSettings({ fontSize: value as number });
  };

  return (
    <Box>
      <Typography variant="subtitle2" gutterBottom id="a11y-font-size-label">
        <Trans>Font Size: {fontSize}rem</Trans>
      </Typography>
      <Slider
        value={fontSize}
        onChange={handleChange}
        min={0.875}
        max={1.5}
        step={0.0625}
        marks={marks}
        valueLabelDisplay="auto"
        valueLabelFormat={(v) => `${v}rem`}
        aria-labelledby="a11y-font-size-label"
        data-testid="a11y-font-size-slider"
      />
    </Box>
  );
};

export default FontSizeControl;
